module.exports = __webpack_public_path__ + "assets/img/116@3x.bab17468.png";